import React, { Fragment } from 'react';
import GooglePlay from '../leap/dist/assets/img/icons/social/googleplay.svg';
import Apple from '../leap/dist/assets/img/icons/social/apple.svg';

export default function SharePage({ links, ...props }) {
  let appleLink = links.find(({ link }) => link.link_style === 'app-store');
  let googleLink = links.find(({ link }) => link.link_style === 'g-play');
  return (
    <div className="d-sm-flex justify-content-center" {...props}>
      <a href={appleLink.link.link_url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-secondary mx-sm-2 mb-3 mb-sm-0">
        <Apple className="injected-svg icon" />
        <span>{appleLink.link.link_text}</span>
      </a>
      <a href={googleLink.link.link_url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-secondary mx-sm-2 mb-3 mb-sm-0">
        <GooglePlay className="injected-svg icon" />
        <span>{googleLink.link.link_text}</span>
      </a >
    </div >
  );
}